var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"1768 1332 11 8"}},[_c('g',{attrs:{"data-name":"Symbole 3 – 13"}},[_c('path',{staticClass:"cls-2",attrs:{"data-name":"Tracé 48","d":"M1778.08 1332.31l-6.154 6.155-2.987-2.987-.747.716 3.585 3.585.115-.12.15.15 6.785-6.751z"}})])])};var toString = function () {return "/builds/agoulay/GUI-drivers/src/assets/svg/icon-valid.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-valid.svg
// module id = j6n+
// module chunks = 2